<template>
<div class="flex w-full vx-row no-gutter justify-center">
  <div class="vx-col sm:w-full md:w-full lg:w-3/5">
    <vx-card class="study-card"> 
      <vs-list>
        <vs-list-header title="문장을 해석하는 연습을 합니다." icon-pack="feather" icon="icon-info"></vs-list-header>
        <!-- <vs-list-item v-for="(content, index) in contentList" :class="contentIndex===index ? 'msg-grp-container text-primary' : 'msg-grp-container'" 
          :key="index" 
          :title="content.sentence" 
          :subtitle="index === contentIndex ? content.translation : ''">
            <vs-chip style="width:80px" v-if="(contentIndex === index)" color="warning mr-0">해석 확인</vs-chip>
        </vs-list-item> -->
      </vs-list>

      <perfect-scrollbar>
        <vs-list class="inner-scroll-height">
          <vs-list-item v-for="(content, index) in contentList" :class="contentIndex===index ? 'msg-grp-container text-primary' : 'msg-grp-container'" 
            :key="index" 
            :title="content.sentence" 
            :subtitle="index === contentIndex ? content.translation : ''">
            <vs-chip style="width:80px" v-if="(contentIndex === index)" color="warning mr-0">해석 확인</vs-chip>
          </vs-list-item>
        </vs-list>
      </perfect-scrollbar>

      <div class="text-center">
        <audio ref="audioPlayer" 
            controls
            v-on:ended="audioFinish"
            preload="auto"
            hidden
            controlsList="nodownload">Your browser does not support the <code>audio</code> element.
        </audio>
      </div>
    </vx-card>
    <top-button-bar @onReload="onReload" @onNext="onNext" @onFinish="onFinish" @onHint="onHint" ></top-button-bar>
  </div>  
</div>
</template>

<script>
import StudyMenuMixin from './StudyMenuMixin'
import TopButtonBar      from './TopButtonBar.vue'
import { PerfectScrollbar } from 'vue2-perfect-scrollbar'

export default {
  mixins: [StudyMenuMixin],
  components: {
    TopButtonBar,
    PerfectScrollbar
  },
  data () {
    return {
      contentList: [],
      contentsLen: 0,
      contentIndex: 0
    }
  },
  computed: {
    content () {
      return this.contentList[this.contentIndex]
    },
    audioPlayer () {
      return this.$refs.audioPlayer
    }
  },
  methods: {
    onReload () {
      this.contentIndex = 0
      this.startAlert()
    },
    onStart () {
      this.playAudio(this.audioPlayer, this.content.audio)
    },
    playAudio (audioPlayer, src) {
      if (this.studyFinished) return
      audioPlayer.src = src
      audioPlayer.play()
    },
    audioFinish () {
      setTimeout(function () {
        if (this.contentIndex >= this.contentsLen - 1) {
          this.onComplete()  
        } else {
          this.contentIndex++
          this.onStart()
        }
      }.bind(this), 1000)
    },
    startAlert () {
      this.startStudyDlg('문장을 해석하는 연습을 합니다.')
    },
    acceptAlert () {
      this.onStart()
    }
  },
  created () {

    const contentJson = JSON.parse(this.sourceContent.contentBody)
    for (let i = 0; i < contentJson.sentence.length; i++) {
      const content = {
        sentence: contentJson.sentence[i],
        translation: contentJson.translation[i],
        audio: this.$buildAudioPath(this.sourceContent.contentCode, i + 1)
      } 
      this.contentList.push(content)
    }

    this.contentsLen = this.contentList.length
    this.startAlert()

  },
  mounted () {
  },
  beforeDestroy () { 
    this.audioPlayer.pause()
  }
}

</script>

<style src="vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css"/>